///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const EditIcon = ({
  height,
  title = messages.edit.defaultMessage,
  width,
  fill = "#343434",
  ...rest
}) => (
  <svg
    aria-labelledby="edit-icon"
    width={height}
    height={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="edit-icon">{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h18v18H-2z" />
      <path
        d="M8.545 4.765l.69.69L2.44 12.25h-.69v-.69l6.795-6.795m2.7-4.515a.75.75 0 00-.525.217L9.347 1.84l2.813 2.813 1.373-1.373a.747.747 0 000-1.057L11.777.467a.736.736 0 00-.533-.217zm-2.7 2.393L.25 10.937v2.813h2.813l8.294-8.295-2.812-2.813z"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default EditIcon;
